import { useMemo } from 'react';
import { useQuery } from 'react-apollo';

import getPrintProductForTemplateAccountCards from '../../graphql/queries/getPrintProductForTemplateAccountCards';
import { ORIENTATION } from '../../constants';

const useTargetAccountCardInputFetch = ({ printProductId }) => {
  const { loading, data: { printProducts = {} } = {} } = useQuery(
    getPrintProductForTemplateAccountCards,
    {
      variables: {
        print_product_id: printProductId,
      },
      skip: !printProductId,
    },
  );

  const templatePrintProduct = useMemo(
    () => printProducts?.records?.[0]?.template_print_product,
    [printProducts],
  );

  const getTargetAccountCardInput = ({ printSize, orientation }) => {
    if (!templatePrintProduct || !printSize) {
      return undefined;
    }
    const orientationToUse = (() => {
      // These product require their orientation be reversed from the standard
      // due to how the photo itself is to be positioned within the card. For instance
      // the 2 - 5x7 is placed on an 7x10 sheet which, when vertical, holds 2 horizontal
      // photos, and when horizontal holds 2 vertical photos.
      if (['2 - 5x7'].includes(printSize.name)) {
        return orientation === ORIENTATION.LANDSCAPE
          ? ORIENTATION.PORTRAIT
          : ORIENTATION.LANDSCAPE;
      }

      return orientation;
    })();
    const templatePrintProductSize = templatePrintProduct?.sizes?.records?.find(
      printProductSize =>
        printProductSize.orientations.includes(orientationToUse) &&
        printProductSize.print_size.name === `${printSize?.name} (T)`,
    );

    if (!templatePrintProductSize) {
      return undefined;
    }

    const cardSide =
      templatePrintProduct?.card?.card_side_groups?.records?.[0]?.card_sides?.records?.find(
        side =>
          side.card_template.print_size.id ===
            templatePrintProductSize?.print_size?.id &&
          side.card_template.orientation === orientationToUse,
      );

    if (!cardSide) {
      return undefined;
    }

    return {
      card_id: templatePrintProduct?.card?.id,
      front_card_side_id: cardSide?.id,
      print_product_configuration: {
        print_product_id: templatePrintProduct?.id,
        print_product_size_id: templatePrintProductSize?.id,
      },
    };
  };

  return {
    loading,
    getTargetAccountCardInput,
  };
};

export default useTargetAccountCardInputFetch;
